import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  isProtocolHasTaskForChangePickEjectLocationUpdate,
  showEjectTipsSwitchModal,
} from 'stores/business/taskListBusinessAction';

import {useDispatch, useSelector} from 'react-redux';
import {useIntl} from 'react-intl';

import {selectOpenedProtocolIsEjectToCaddy} from 'stores/selectors/protocolSelectors';
import {setOpenedProtocolEjectToCaddy} from 'stores/actions/protocolAction';
import FastSwitch from 'components/Switch/FastSwitch';
import TaskInfoWrapper from '../Components/TaskInfoWrapper';

import {ProtocolEditorContext} from '../ContextProviders/ProtocolEditorContext';

import {CardType, ProtocolEditorViewMode, TaskType} from '../../../constants/dataEnum';

import './TipCaddy.scss';

function TipCaddy({
  onClick,
  itemID,
  header,
  tasks,
  runtimeMode,
  protocolEditorMode,
  isHighVolume,
  showCaddyOnly,
  showCaddySwitch,
  disableSwitch,
}) {
  const intl = useIntl();
  const {volumeDetailViewChecked, selectedCardRef} = useContext(ProtocolEditorContext) || {};
  const task = tasks[0];
  const dispatch = useDispatch();
  const isEjectToCaddy = useSelector(selectOpenedProtocolIsEjectToCaddy);

  const handleSwitchChange = (checked) => {
    const needTaskLocationChange = dispatch(isProtocolHasTaskForChangePickEjectLocationUpdate());
    if (needTaskLocationChange) {
      dispatch(showEjectTipsSwitchModal(checked));
    } else {
      dispatch(setOpenedProtocolEjectToCaddy(checked));
    }
  };

  return (
    <div className="tip-caddy-wrapper">
      <TaskInfoWrapper
        tasks={protocolEditorMode === ProtocolEditorViewMode.SIMPLE_TRANSFER ? tasks : []}
        showTaskVolume={
          volumeDetailViewChecked &&
          !runtimeMode &&
          !showCaddyOnly &&
          selectedCardRef.current?.type !== CardType.NORMALIZATION &&
          selectedCardRef.current?.type !== CardType.SERIAL_DILUTION &&
          selectedCardRef.current?.type !== CardType.BROADCAST &&
          selectedCardRef.current?.type !== CardType.POOLING
        }
        style={{position: 'absolute'}}
        showTaskNumber={
          !runtimeMode &&
          !showCaddyOnly &&
          selectedCardRef.current?.type !== CardType.NORMALIZATION &&
          selectedCardRef.current?.type !== CardType.SERIAL_DILUTION &&
          selectedCardRef.current?.type !== CardType.BROADCAST &&
          selectedCardRef.current?.type !== CardType.POOLING
        }
      >
        <div className="tip-caddy">
          {showCaddySwitch && !showCaddyOnly ? (
            <div className="eject-tips-to-caddy">
              <p className="eject-tips-to-caddy-label">
                {intl.formatMessage({
                  id: 'protocolEditor.tipsWasteToCaddy.switch.label',
                })}
              </p>
              <FastSwitch
                size="xs"
                checked={isEjectToCaddy}
                onChange={handleSwitchChange}
                withIcon
                id="isEjectToCaddySwitch"
                disabled={disableSwitch}
              />
            </div>
          ) : (
            ''
          )}
          <img
            className="tip-caddy-image"
            draggable={false}
            src={`./svg/protocol-editor/${isEjectToCaddy && showCaddySwitch && !showCaddyOnly ? 'tips-waste-to-caddy' : `tip-caddy${isHighVolume ? '-high-volume' : ''}`}.svg`}
            alt="Tip Caddy"
            role="presentation"
            onClick={() => onClick(itemID)}
          />
          {!showCaddyOnly &&
            (task ? (
              <div className="tip-caddy-status">
                <span>{task.type === TaskType.EJECT_TIP ? 'Ejected' : 'Picked'}</span>
                &nbsp;
                <span className="green">{`[${task.rowTipCount * task.columnTipCount}]`}</span>
                &nbsp;
                <span>tips</span>
              </div>
            ) : (
              <span className={`tip-caddy-header ${isEjectToCaddy && showCaddySwitch ? 'eject-tip-text' : ''}`}>
                {header}
              </span>
            ))}
        </div>
      </TaskInfoWrapper>
    </div>
  );
}

TipCaddy.propTypes = {
  itemID: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  header: PropTypes.string,
  tasks: PropTypes.array,
  runtimeMode: PropTypes.bool,
  protocolEditorMode: PropTypes.string,
  isHighVolume: PropTypes.bool,
  showCaddyOnly: PropTypes.bool,
  showCaddySwitch: PropTypes.bool,
  disableSwitch: PropTypes.bool,
};

TipCaddy.defaultProps = {
  onClick: () => {},
  header: '',
  tasks: [],
  runtimeMode: false,
  protocolEditorMode: '',
  isHighVolume: false,
  showCaddyOnly: false,
  showCaddySwitch: true,
  disableSwitch: true,
};

const areEqual = (prevProps, nextProps) =>
  prevProps.itemID === nextProps.itemID &&
  prevProps.header === nextProps.header &&
  prevProps.runtimeMode === nextProps.runtimeMode &&
  prevProps.protocolEditorMode === nextProps.protocolEditorMode &&
  prevProps.showCaddySwitch === nextProps.showCaddySwitch &&
  prevProps.disableSwitch === nextProps.disableSwitch &&
  _.isEqual(prevProps.tasks, nextProps.tasks) &&
  _.isEqual(prevProps.isHighVolume, nextProps.isHighVolume) &&
  _.isEqual(prevProps.showCaddyOnly, nextProps.showCaddyOnly);

export default React.memo(TipCaddy, areEqual);
